export default "__VITE_ASSET__qIA8MwEd__"